/**
 * @generated SignedSource<<0a701e2998df055906f249d5ed72b556>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TVTodoEditAssigneesPopoverRolesMutation$variables = {
  id: string;
  roleIds: ReadonlyArray<string>;
};
export type TVTodoEditAssigneesPopoverRolesMutation$data = {
  readonly todo: {
    readonly updateAssignedRoles: {
      readonly assignedRoles: ReadonlyArray<{
        readonly role: {
          readonly id: string;
        };
      }>;
      readonly id: string;
    };
  } | null;
};
export type TVTodoEditAssigneesPopoverRolesMutation$rawResponse = {
  readonly todo: {
    readonly updateAssignedRoles: {
      readonly assignedRoles: ReadonlyArray<{
        readonly id: string;
        readonly role: {
          readonly id: string;
        };
      }>;
      readonly id: string;
    };
  } | null;
};
export type TVTodoEditAssigneesPopoverRolesMutation = {
  rawResponse: TVTodoEditAssigneesPopoverRolesMutation$rawResponse;
  response: TVTodoEditAssigneesPopoverRolesMutation$data;
  variables: TVTodoEditAssigneesPopoverRolesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "roleIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "todoId",
    "variableName": "id"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "updateAssignedRoleIds",
    "variableName": "roleIds"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "EmployeeRole",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": [
    (v3/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TVTodoEditAssigneesPopoverRolesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoMutation",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "updateAssignedRoles",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AssignedRole",
                "kind": "LinkedField",
                "name": "assignedRoles",
                "plural": true,
                "selections": [
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TVTodoEditAssigneesPopoverRolesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoMutation",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "updateAssignedRoles",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AssignedRole",
                "kind": "LinkedField",
                "name": "assignedRoles",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2ccded9385b2158e373a552bc9bd4ba8",
    "id": null,
    "metadata": {},
    "name": "TVTodoEditAssigneesPopoverRolesMutation",
    "operationKind": "mutation",
    "text": "mutation TVTodoEditAssigneesPopoverRolesMutation(\n  $id: ID!\n  $roleIds: [ID!]!\n) {\n  todo(todoId: $id) {\n    updateAssignedRoles(updateAssignedRoleIds: $roleIds) {\n      id\n      assignedRoles {\n        role {\n          id\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9aa6fd4d59d84a10237b8c4500ab8ad9";

export default node;
